import React from "react";
import LibrarySong from "./LibrarySong";

const Library = ({
  songs,
  setCurrentSong,
  currentSong,
  isPlaying,
  setIsPlaying,
  setSongs,
  isLibraryOpen,
  setIsLibraryOpen,
}) => {
  return (
    <div className={`library ${isLibraryOpen ? "active-library" : ""}`}>
      <h2>Library</h2>
      <div className="library-songs">
        {songs.map((song) => (
          <LibrarySong
            setIsLibraryOpen={setIsLibraryOpen}
            setSongs={setSongs}
            isPlaying={isPlaying}
            setIsPlaying={setIsPlaying}
            songs={songs}
            song={song}
            setCurrentSong={setCurrentSong}
            currentSong={currentSong}
            id={song.id}
            key={song.id}
          />
        ))}
      </div>
    </div>
  );
};

export default Library;
